import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Menu, MenuItem } from "@mui/material";
import { getStatusInfo } from "@pages/Quotes/Quotes.contants";
import { StyledStatusBadge } from "@pages/Quotes/quotes.style";
import React, { useState } from "react";
import { toast } from "react-toastify";
import { useUpdateQuoteStatusMutation } from "store/quote/quoteApi";
const StatusDropdown = ({ quote }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const [updateQuoteStatus] = useUpdateQuoteStatusMutation();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = async (newStatus) => {
    setAnchorEl(null);

    if (newStatus && newStatus !== quote.status) {
      try {
        await updateQuoteStatus({
          id: quote._id,
          quoteStatus: newStatus,
        }).unwrap(); // important si tu utilises RTK Query
        toast.success("Statut mis à jour avec succès !");
      } catch (error) {
        console.error("Erreur lors de la mise à jour du statut :", error);
        toast.error("Erreur lors du changement de statut. Veuillez réessayer.");
      }
    }
  };

  const statusOptions = ["pending", "accepted", "refused", "invoiced"];
  const { label, color, Icon } = getStatusInfo(quote.status);

  return (
    <>
      <StyledStatusBadge
        color={color}
        title={label}
        onClick={handleClick}
        style={{ cursor: "pointer", display: "flex", alignItems: "center" }}>
        <Icon style={{ fontSize: 20, marginRight: 6 }} />
        {label}
        <ArrowDropDownIcon />
      </StyledStatusBadge>

      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        {statusOptions.map((status) => {
          const { label: optionLabel, Icon: OptionIcon } =
            getStatusInfo(status);
          return (
            <MenuItem key={status} onClick={() => handleClose(status)}>
              <OptionIcon style={{ fontSize: 18, marginRight: 8 }} />
              {optionLabel}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default StatusDropdown;
